import {
  innerHighlightedIcon,
  outerHighlightedIcon,
  singleDimensionIcon,
} from './styles/DataPointShape.sty.js';

/** @internal */
export interface SingleDataPointShapeProps {
  active?: boolean;
  color: string;
}

/** @internal */
export const SingleDataPointShape = ({
  color,
  active = false,
}: SingleDataPointShapeProps) => {
  return active ? (
    <span className={outerHighlightedIcon({ singleLine: true })}>
      <span
        style={{ backgroundColor: color }}
        className={innerHighlightedIcon({ singleLine: true })}
      />
    </span>
  ) : (
    <span style={{ backgroundColor: color }} className={singleDimensionIcon} />
  );
};

SingleDataPointShape['displayName'] = 'SingleDataPointShape';
